import { User } from "../user";
import { TransactionType } from "./enums/Transaction.type";


export class TransactionFilter {
  ID: string;
  NAME: string;
  NAICS: string[];
  SIC: string[];
  UPDATE_DATE: Date;
  USER: User;

  REVENUE_MIN: number;
  REVENUE_MAX: number;
  SDE_MIN: number;
  SDE_MAX: number;
  PRICE_MIN: number;
  PRICE_MAX: number;
  PRICE_REVENUE_MIN: number;
  PRICE_REVENUE_MAX: number;
  PRICE_SDE_MIN: number;
  PRICE_SDE_MAX: number;
  SALE_DATE_MIN: string;
  SALE_DATE_MAX: string;
  SEARCH: string;
  TYPE: TransactionType;
  PAGE_SIZE: number;
  INCLUDE: string[];
  EXCLUDE: string[];
  HIDDEN: string[];
  SELECTED_IDS: string[];
  PERCENTILE: number;
  TRAN_TYPE: string;
  USE:boolean;

  //helpers
  isLoading: boolean;

  constructor(){
    this.REVENUE_MIN = null;
    this.REVENUE_MAX = null;
    this.SDE_MIN = null;
    this.SDE_MAX = null;
    this.PRICE_MIN = null;
    this.PRICE_MAX = null;
    this.PRICE_REVENUE_MIN = null;
    this.PRICE_REVENUE_MAX = null;
    this.PRICE_SDE_MIN = null;
    this.PRICE_SDE_MAX = null;
    this.SALE_DATE_MIN = '';
    this.SALE_DATE_MAX = '';
    this.SEARCH = '';
    this.TYPE = null;
    this.PAGE_SIZE = 50;
    this.INCLUDE = [];
    this.EXCLUDE = [];
    this.HIDDEN = [];
    this.SELECTED_IDS = [];
    this.PERCENTILE = 50;
    this.TRAN_TYPE = null;
    this.SIC = [];
    this.NAICS = [];
    this.USE = false;
  }

  static parse(json: any): TransactionFilter {
    if (json) {
      const f = new TransactionFilter();

      f.ID = json.ID;
      f.NAME = json.NAME;
      f.UPDATE_DATE = json.UPDATE_DATE;
      f.NAICS = json.NAICS ? json.NAICS : [];
      f.SIC = json.SIC ? json.SIC : [];
      f.USER = json.USER ? User.parse(json.USER) : null;

      f.REVENUE_MIN = json.REVENUE_MIN;
      f.REVENUE_MAX = json.REVENUE_MAX;
      f.SDE_MIN = json.SDE_MIN;
      f.SDE_MAX = json.SDE_MAX;
      f.PRICE_MIN = json.PRICE_MIN;
      f.PRICE_MAX = json.PRICE_MAX;
      f.PRICE_REVENUE_MIN = json.PRICE_REVENUE_MIN;
      f.PRICE_REVENUE_MAX = json.PRICE_REVENUE_MAX;
      f.PRICE_SDE_MIN = json.PRICE_SDE_MIN;
      f.PRICE_SDE_MAX = json.PRICE_SDE_MAX;
      f.SALE_DATE_MIN = json.SALE_DATE_MIN;
      f.SALE_DATE_MAX = json.SALE_DATE_MAX;
      f.SEARCH = json.SEARCH;
      f.TRAN_TYPE = json.TRAN_TYPE;
      
      if(json.USE)
        f.USE = json.USE;

      if(f.TYPE)
        f.TYPE = TransactionType[<string>json.TYPE];

      f.PAGE_SIZE = json.PAGE_SIZE;
      f.INCLUDE = json.INCLUDE;
      f.EXCLUDE = json.EXCLUDE;
      f.HIDDEN = json.HIDDEN;
      f.SELECTED_IDS = json.SELECTED_IDS;
      f.PERCENTILE = json.PERCENTILE;

      return f;
    } else { return null; }
  }

  static parseArray(json: any[]): TransactionFilter[] {
    const arr = [];
    if (json) {
      for (const j of json) {
        if (j) arr.push(TransactionFilter.parse(j));
      }
    }

    return arr;
  }
}
